import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "alertTypeInputs",
    "webhookInputs",
    "webhookVariables",
    "webhookOptionalLabel",
    "expirationInputs",
    "recordChangeInputs",
    "expirationWebhookVars",
    "singleExpirationWebhookVars",
    "websiteMonitorWebhookVars",
    "passwordViewWebhookVars",
    "recordChangeWebhookVars",
    "passwordChangeWebhookVars",
    "emailGroup"
  ]

  connect() {
    this.updateVisibility()
  }

  updateAlertTypeInputs() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selectedAlertType = this.getSelectedAlertType()
    this.hideAllSections()
    this.hideAllWebhookVariables()

    switch (selectedAlertType) {
      case 'single_expiration':
        this.showTarget('expirationInputs')
        this.showTarget('singleExpirationWebhookVars')
        break
      case 'expiration':
        this.showTarget('expirationInputs')
        this.showTarget('expirationWebhookVars')
        break
      case 'record_change':
        this.showTarget('recordChangeInputs')
        this.showTarget('recordChangeWebhookVars')
        break
      case 'website_monitor':
      case 'password_view':
      case 'password_change':
        if (selectedAlertType === 'website_monitor') {
          this.showTarget('websiteMonitorWebhookVars')
        } else if (selectedAlertType === 'password_view') {
          this.showTarget('passwordViewWebhookVars')
        } else if (selectedAlertType === 'password_change') {
          this.showTarget('passwordChangeWebhookVars')
        }
        break
    }

    if (selectedAlertType === 'record_change') {
      this.emailGroupTarget.classList.add('hidden')
      this.webhookOptionalLabelTarget.classList.add('hidden')
    } else {
      this.emailGroupTarget.classList.remove('hidden')
      this.webhookOptionalLabelTarget.classList.remove('hidden')
    }
  }

  getSelectedAlertType() {
    const checkedRadio = this.element.querySelector('input[name="alert[alert_type]"]:checked')
    return checkedRadio ? checkedRadio.value : null
  }

  hideAllSections() {
    const sections = this.element.querySelectorAll('.alert-type-section')
    sections.forEach(section => {
      section.classList.add('hidden')
    })
  }

  hideAllWebhookVariables() {
    const webhookSections = this.element.querySelectorAll('.webhook-vars-section')
    webhookSections.forEach(section => {
      section.classList.add('hidden')
    })
  }

  showTarget(targetName) {
    if (this[`${targetName}Target`]) {
      this[`${targetName}Target`].classList.remove('hidden')
    }
  }

} 